import React from 'react'
import {
    Flex,
    Text,
    useStyleConfig,
    useMultiStyleConfig,
    useMediaQuery,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import RecipeProductsCarousel from './recipe-products-carousel'
import RecipeUtilityTile from './recipe-utility-tile'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import {FormattedMessage} from 'react-intl'
import SanitizedHtml from '../../html-sanitizer'
import RecipeSuggestionsBlocks from './recipe-suggestions-block'

const CAROUSEL_ITEMS_THRESHOLDA = 4

const RecipeProductSuggestions = ({
    textBoxTitle = '',
    madeWith = [],
    toolsGroup = [],
    isMainProduct = false,
}) => {
    const styles = useStyleConfig('Sorting', {variant: 'recipesCarousel'})
    const recipeStyles = useMultiStyleConfig('RecipeDetails', {})
    const suggestionsStyles = recipeStyles?.productSuggestion ?? []
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(1023)})`)
    const mainProductText = madeWith?.[0]?.shortDescription || ''
    return (
        <Flex {...suggestionsStyles?.suggestionsContainer}>
            <Flex
                {...suggestionsStyles?.textBoxTileContainer}
                marginRight={madeWith.length === 0 ? {base: 'small.base', lg: 'small.lg'} : 'unset'}
                borderRight={!isMainProduct && !isMobile ? `${remCalc(1)} solid #efefef` : 'unset'}
                flexDir="column"
                justify="flex-start"
            >
                <Text {...suggestionsStyles?.textBoxTitleText}>{textBoxTitle}</Text>

                {isMainProduct && (
                    <SanitizedHtml
                        as={Flex}
                        html={mainProductText}
                        {...suggestionsStyles?.textBoxBodyText}
                    />
                )}
            </Flex>
            {madeWith.length > 0 && isMainProduct && (
                <Flex
                    borderX={isMobile ? 'unset' : `${remCalc(1)} solid #efefef`}
                    {...suggestionsStyles?.maidWithContainer}
                    marginRight={{base: 'small.base', lg: 'small.lg'}}
                    maxW={{
                        base: remCalc(343),
                        sm: remCalc(343),
                        md: remCalc(400),
                        lg: 'unset',
                    }}
                    flexDir="column"
                >
                    <Text
                        textAlign="center"
                        textStyle="body-small"
                        fontWeight="medium"
                        color="text.secondary"
                    >
                        <FormattedMessage
                            id="recipes.details_page.carousel.product"
                            defaultMessage="PRODUCT"
                        />
                    </Text>
                    <RecipeUtilityTile
                        key={`main-item-${madeWith?.id}`}
                        styles={styles}
                        tile={madeWith?.[0]}
                        variant="white"
                    />
                </Flex>
            )}
            {madeWith?.length > 0 && (
                <Flex
                    height="auto"
                    width={{base: '100%', lg: '70%'}}
                    flexDir="column"
                    maxW={{
                        base: remCalc(343),
                        sm: remCalc(343),
                        md: remCalc(400),
                        lg: 'unset',
                    }}
                >
                    {isMainProduct && toolsGroup.length > 0 && (
                        <Text
                            textAlign="center"
                            textStyle="body-small"
                            fontWeight="medium"
                            color="text.secondary"
                        >
                            <FormattedMessage
                                id="recipes.details_page.carousel.attachments"
                                defaultMessage="ATTACHMENTS"
                            />
                        </Text>
                    )}

                    {!isMainProduct && madeWith.length > 1 && (
                        <Text
                            textAlign="center"
                            textStyle="body-small"
                            fontWeight="medium"
                            color="text.secondary"
                        >
                            <FormattedMessage
                                id="recipes.details_page.carousel.products"
                                defaultMessage="PRODUCTS"
                            />
                        </Text>
                    )}

                    {isMainProduct ? (
                        toolsGroup.length > CAROUSEL_ITEMS_THRESHOLDA ? (
                            <RecipeProductsCarousel productsGroup={toolsGroup} />
                        ) : (
                            <RecipeSuggestionsBlocks productsGroup={toolsGroup} styles={styles} />
                        )
                    ) : madeWith.length > CAROUSEL_ITEMS_THRESHOLDA ? (
                        <RecipeProductsCarousel productsGroup={madeWith.slice(1)} />
                    ) : (
                        <RecipeSuggestionsBlocks
                            productsGroup={madeWith.slice(1)}
                            styles={styles}
                        />
                    )}
                </Flex>
            )}
        </Flex>
    )
}

RecipeProductSuggestions.propTypes = {
    textBoxTitle: PropTypes.string,
    madeWith: PropTypes.array,
    toolsGroup: PropTypes.array,
    isMainProduct: PropTypes.bool,
}

export default RecipeProductSuggestions
